<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6.71,9.29C6.53,9.11,6.28,9,6,9C5.45,9,5,9.45,5,10C5,10.28,5.109999999999999,10.53,5.29,10.71C5.29,10.71,7.29,12.71,7.29,12.71C7.47,12.89,7.72,13,8,13C8.39,13,8.719999999999999,12.77,8.89,12.44C8.89,12.44,8.9,12.44,8.9,12.44C8.9,12.44,10.9,8.44,10.9,8.44C10.9,8.44,10.89,8.44,10.89,8.44C10.95,8.31,11,8.16,11,8C11,7.45,10.55,7,10,7C9.61,7,9.280000000000001,7.23,9.11,7.56C9.11,7.56,9.1,7.56,9.1,7.56C9.1,7.56,7.72,10.32,7.72,10.32C7.72,10.32,6.71,9.29,6.71,9.29C6.71,9.29,6.71,9.29,6.71,9.29ZM9,0C9,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1,2,15,2,15C2,15.55,2.45,16,3,16C3,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,5,14,5C14,5,9,0,9,0C9,0,9,0,9,0ZM12,14C12,14,4,14,4,14C4,14,4,2,4,2C4,2,8,2,8,2C8,2,8,6,8,6C8,6,12,6,12,6C12,6,12,14,12,14C12,14,12,14,12,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Saved',
} as DefineComponent
</script>
